import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";


const TaskService = {

    getTimeLine : async (id) => {
        try {
            const request =  await axios.get(`${ENDPOINT.timeline}?taskId=${id}`); 
            console.log(`${ENDPOINT.timeline}?taskId${id}`);
            
            return request.data;
        } catch (error) {
            console.error(error);
            
        }
    },

     createTimeLine : async (data) => {
        try {
            const request =  await axios.post(`${ENDPOINT.timeline}`, data ); 
            return request.data;
        } catch (error) {
            console.error(error);
            
        }
    },

    updateTask : async (data, id) => {
        try {
            const request =  await axios.put(`${ENDPOINT.task}/${id}`, data ); 
            return request.data;
        } catch (error) {
            console.error(error);
            
        }
    },

     createTask : async (data) => {
        try {
            const request =  await axios.post(`${ENDPOINT.task}`, data ); 
            return request.data;
        } catch (error) {
            console.error(error);
            
        }
    },

    getTasksByProjectId: async (projectId) => {
    try {
        const response = await axios.get(`${ENDPOINT.task}?project_id=${projectId}`);
        return response.data;
    } catch (error) {
        console.error( error);
     
    }

    
},


  getAssignedTasks: async (userId) => {
    try {
      const response = await axios.get(`${ENDPOINT.task}/assigned-to/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching assigned tasks:", error);
      return null;
    }
  },


  getTasksByUserId: async (userId) => {
  try {
    const response = await axios.get(`${ENDPOINT.task}/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user tasks:", error);
    return null;
  }
},





}




export default TaskService;